import { AdminUserCreateDTORole } from '@/api/models';

/**
 * Human-readable labels for user roles
 */
export const ROLE_LABELS: Record<AdminUserCreateDTORole, string> = {
  [AdminUserCreateDTORole.user]: 'Regular User',
  [AdminUserCreateDTORole.platform_admin]: 'Platform Admin',
  [AdminUserCreateDTORole.platform_support]: 'Platform Support',
  [AdminUserCreateDTORole.platform_marketing]: 'Platform Marketing',
  [AdminUserCreateDTORole.business_owner]: 'Business Owner',
  [AdminUserCreateDTORole.business_manager]: 'Business Manager',
  [AdminUserCreateDTORole.business_staff]: 'Business Staff',
};

/**
 * Extended labels with descriptions for forms
 */
export const ROLE_LABELS_EXTENDED: Record<AdminUserCreateDTORole, string> = {
  [AdminUserCreateDTORole.user]: 'Regular User',
  [AdminUserCreateDTORole.platform_admin]:
    'Platform Admin - Full system access',
  [AdminUserCreateDTORole.platform_support]:
    'Platform Support - Support access',
  [AdminUserCreateDTORole.platform_marketing]:
    'Platform Marketing - Analytics access',
  [AdminUserCreateDTORole.business_owner]: 'Business Owner - Manage businesses',
  [AdminUserCreateDTORole.business_manager]:
    'Business Manager - Manage assigned business',
  [AdminUserCreateDTORole.business_staff]:
    'Business Staff - Limited business access',
};

/**
 * Platform roles available for selection in admin forms
 */
export const PLATFORM_ROLES = [
  { value: AdminUserCreateDTORole.user, label: ROLE_LABELS_EXTENDED.user },
  {
    value: AdminUserCreateDTORole.platform_admin,
    label: ROLE_LABELS_EXTENDED.platform_admin,
  },
  {
    value: AdminUserCreateDTORole.platform_support,
    label: ROLE_LABELS_EXTENDED.platform_support,
  },
  {
    value: AdminUserCreateDTORole.platform_marketing,
    label: ROLE_LABELS_EXTENDED.platform_marketing,
  },
];

/**
 * Helper to get role label from string (handles unknown roles gracefully)
 */
export const getRoleLabel = (role: string): string => {
  return ROLE_LABELS[role as AdminUserCreateDTORole] || role;
};
